import { ReactComponent as ArrowDownSvg } from '@apps/gated-2021/assets/arrow-down-two.svg';
import React from 'react';
import * as styled from './scroll-button.styled';

export const ScrollButton: React.FC<{
    scrollTo: React.RefObject<HTMLDivElement>;
}> = ({ scrollTo }) => {
    return (
        <styled.ScrollButton
            onClick={() => {
                scrollTo.current?.scrollIntoView({ behavior: 'smooth' });
            }}
        >
            <ArrowDownSvg />
        </styled.ScrollButton>
    );
};
